<template>
  <div class="maintenance-notify">
    <div class="maintenance-notify__content">
      <p class="maintenance-notify__text">Platform maintenance is currently in progress.</p>
      <p class="maintenance-notify__text maintenance-notify__text--highlight">
        Scanning is temporarily disabled.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MaintenanceNotification',
};
</script>

<style lang="scss" scoped>
.maintenance-notify {
  width: 100%;
  min-height: 46px;
  background-color: #dc2626;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 14px 20px;

  &__content {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  &__text {
    display: flex;
    align-items: center;
    margin: 0;
    font-family: Cabin, serif;
    font-size: 14px;
    line-height: 140%;
    color: #ffffff;

    &--highlight {
      color: #ffe066;
      font-weight: bold;
    }
  }
}

@media (max-width: 450px) {
  .maintenance-notify {
    min-height: 51px;
    padding: 6px 20px;

    &__content {
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
    }
  }
}
</style>
